import { Edge, Node, XYPosition } from "reactflow";
import { PortInfo } from ".";
import { BdaApplication } from "../models/BdaApplication";
import { BdaService } from "../models/BdaService";
import { UsedItem } from "../models/generics";
import { NodeType } from "../models/Designer";

const PROPERTY_CAPTURING_REGEX = /(?<type>input|output)-(?<asset>dataset|model)/;

export interface GraphV2 {
  nodes: Node<any, NodeType>[];
  edges: Edge[];
}

export function translateGraph(graph: any[]): GraphV2 {
  return graph.reduce<GraphV2>((acc, curr) => {
    if (Object.hasOwn(curr, 'source') && Object.hasOwn(curr, 'target')) acc.edges.push(curr);
    else acc.nodes.push(curr);
    return acc;
  }, { nodes: [], edges: [] });
}

// TODO improve checks to handle new 'generic' ports?
export function validateConnection(source: string, target: string) {
  const sourceMatches = source.match(PROPERTY_CAPTURING_REGEX);
  const targetMatches = target.match(PROPERTY_CAPTURING_REGEX);

  return sourceMatches?.groups?.asset === targetMatches?.groups?.asset;
}

export function getNodeId(node: any) {
  return getIdFromUUID(node.id);
}

export function getIdFromUUID(uuid: string) {
  const stringID = uuid.split('__')[0];
  return Number.parseInt(stringID);
}

export function getNodeFromUUID(uuid: string, elements: any[]) {
  const id = getIdFromUUID(uuid);
  return elements.find(element => element.id === id);
}

export function validateApplication(application: BdaApplication) {
  const errors = application.workflows[0].services
    .map(service => {
      const missingProperties = service.properties
        .filter(prop => !prop.invisible && prop.mandatory && (prop.value === null || prop.value === ""))
        .map(prop => prop.key);

      return {
        service: service.name,
        missingProperties,
      };
    })
    .filter(item => item.missingProperties.length > 0);

  return {
    valid: errors.length === 0,
    errors,
  }
}

export type Graph = (Node & Edge)[];

export interface NewNode {
  id: string;
  type: NodeType;
  position: XYPosition;
  data: any;
}

// TODO set type for InspectingItem
export function generateItemFromPortInfo(portInfo: PortInfo, edges: Edge[], usedItems: UsedItem<any>[]): any {
  const service = usedItems.find(item => item.ref === portInfo.nodeId) as UsedItem<BdaService>;

  if (portInfo.id.includes('input-dataset')) {
    const connection = edges.find(link => link.target === portInfo.nodeId && link.targetHandle === portInfo.id);

    // if (!connection) return;

    if (connection?.sourceHandle?.includes('output-dataset')) return { isNodePort: true, cascade: true, type: portInfo.id, name: `${portInfo.nodeName} - ${portInfo.id}`, service };

    // if (service.inputs?.find(input => input.id === portInfo.id)?.dataset?.type !== "table") return;

  }
  else if (portInfo.id.includes('output-dataset') || portInfo.id.includes('output-model')) return { isNodePort: true, isOutput: true, type: portInfo.id, name: `${portInfo.nodeName} - ${portInfo.id}`, service };
  else if (portInfo.generic) return { isNodePort: true, type: portInfo.id, name: `${portInfo.nodeName} - ${portInfo.id}`, description: portInfo.description, service };
  return { isNodePort: true, type: portInfo.id, name: `${portInfo.nodeName} - ${portInfo.id}`, service };
}

export function getNodeInputEdge(node: Node, edges: Edge[], port: string) {
  return edges.find(el => el.targetHandle === port && el.target === node.id);
}